import axios from 'axios';

const API_URL = '/api/courses/';

// Get all courses
const getCourses = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

// Get course by ID
const getCourseById = async (courseId) => {
  const response = await axios.get(API_URL + courseId);
  return response.data;
};

// Get enrolled courses
const getEnrolledCourses = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.get('/api/enrollments/my-courses', config);
  return response.data;
};

const courseService = {
  getCourses,
  getCourseById,
  getEnrolledCourses,
};

export default courseService;